/** The ticket page's spot check, the pure half (M5 round nine; ported from the prototype's TicketDetail and InboxScreen): when the
 *  bar shows in the reply bar's place, which keys answer it, which reply to check next, and what the kit's row is handed. */
export type SpotCheckBarState = { verdict: "good" | "wrong" | null } | null;
/** the kit's verdict: the product's `due` (and a reply the sample left out) read as unchecked */
export const rowSpotCheck = (v: string | null | undefined): "good" | "wrong" | null => (v === "good" || v === "wrong" ? v : null);
/** the bar shows on a reply the AI sent on its own while the ticket is resolved and not spam; a verdict shows with Undo */
export function spotCheckBar(t: { aiResolved: boolean; status: string; spam: boolean; spotCheck: string | null }): SpotCheckBarState {
  if (!t.aiResolved || t.status !== "resolved" || t.spam) return null;
  return { verdict: rowSpotCheck(t.spotCheck) };
}
/** G and W answer the bar while it asks; never with ⌘ or Ctrl, never once a verdict is given */
export function spotCheckKey(e: { key: string; metaKey?: boolean; ctrlKey?: boolean; altKey?: boolean }, bar: SpotCheckBarState): "good" | "wrong" | null {
  if (!bar || bar.verdict !== null || e.metaKey || e.ctrlKey || e.altKey) return null;
  const k = e.key.toLowerCase();
  return k === "g" ? "good" : k === "w" ? "wrong" : null;
}
/** after a verdict: the next unchecked reply after this one, else the first unchecked one other than this, else none (back to the list) */
export function nextToCheck(rows: { number: number; spotCheck: string | null }[], current: number): number | null {
  const unchecked = (r: { spotCheck: string | null }) => rowSpotCheck(r.spotCheck) === null;
  const i = rows.findIndex((r) => r.number === current);
  const after = rows.find((r, j) => j > i && unchecked(r));
  return after?.number ?? rows.find((r) => unchecked(r) && r.number !== current)?.number ?? null;
}
